// extracted by mini-css-extract-plugin
export default {"tab-switch-wrapper":"Profile_tab-switch-wrapper__a3-gf","title":"Profile_title__aENcO","title--selected":"Profile_title--selected__llDoA"};